export const SET_ENTITIES_LISTINGS =  'SET_ENTITIES_LISTINGS';
export const ADD_ENTITY_LISTING_GRAPHIC = 'ADD_ENTITY_LISTING_GRAPHIC';
export const REMOVE_ENTITY_LISTING_GRAPHIC = 'REMOVE_ENTITY_LISTING_GRAPHIC';
export const SET_ENTITIES_SUPPLIERS =  'SET_ENTITIES_SUPPLIERS';
export const UPDATE_ENTITY = 'UPDATE_ENTITY';
export const SET_ENTITIES = 'SET_ENTITIES';
export const ADD_ENTITY_LISTING_CUSTOM_ITEM = 'ADD_ENTITY_LISTING_CUSTOM_ITEM';
export const REMOVE_ENTITY = 'REMOVE_ENTITY';
export const ADD_ENTITY = 'ADD_ENTITY';
export const SET_PRIVATE_ENTITIES_LISTINGS = "SET_PRIVATE_ENTITIES_LISTINGS";
export const ADD_PRIVATE_ENTITIES_LISTINGS = "ADD_PRIVATE_ENTITIES_LISTINGS";
export const ADD_PRIVATE_ENTITY = "ADD_PRIVATE_ENTITY";
export const UPDATE_PRIVATE_ENTITY = "UPDATE_PRIVATE_ENTITY";
export const CLEAR_PRIVATE_ENTITIES_LISTINGS = "CLEAR_PRIVATE_ENTITIES_LISTINGS";



/** WEBPACK FOOTER **
 ** ./client/actions/entityActions.js
 **/